import '../css/Content.css';
import React, { useState, useEffect, useRef  } from 'react';
// import { Carousel, Modal, Button } from 'react-bootstrap'
import 'bootstrap/dist/css/bootstrap.min.css'
import scormAPI from '../scorm';
import Page1 from './module1/Page1'
import Page2 from './module1/Page2'
import Page3 from './module1/Page3'
import Page4 from './module1/Page4'
import Page5 from './module1/Page5'
import Page6 from './module1/Page6'
import Page7 from './module1/Page7'
import Page8 from './module1/Page8'
import Page9 from './module1/Page9'
import Page10 from './module1/Page10'
import Page11 from './module1/Page11'
import Page12 from './module1/Page12'
import Page13 from './module1/Page13'
import Page14 from './module1/Page14'
import Page15 from './module1/Page15'
import Page16 from './module1/Page16'
import Page17 from './module1/Page17'
import Page18 from './module1/Page18'
import Page19 from './module1/Page19'
import Page20 from './module1/Page20'
import Page21 from './module1/Page21'
import Page22 from './module1/Page22'
import Page23 from './module1/Page23'
import Page24 from './module1/Page24'
import Page25 from './module1/Page25'
import Page26 from './module1/Page26'
const Lesson = ({ className, navigationMode = "pagination" }) => {

  const [currentSection, setCurrentSection] = useState(0);
  const [inputPage, setInputPage] = useState(1); // controla o input

  const finalizado = () => {
    if (!scormAPI.getValue("cmi.core.lesson_status")) {
        console.error("SCORM API não está ativa, não é possível finalizar a lição."); 
        return;
    }

    console.log("SCORM ainda está ativo, tentando salvar progresso...");
    
    scormAPI.setValue('cmi.core.lesson_status', 'completed');
    scormAPI.commit();

    setTimeout(() => {
        scormAPI.terminate();
    }, 1000);
 };

 const sections = [
    <section key="1" style={{  height: 'calc(100vh - 50px)'}}>
      <div className="container" style={{height: 'calc(100vh - 50px)'}}>
        <Page1 />
      </div>
    </section>,
    
    <section key="2" style={{ background: '#258896ff', minHeight: 'calc(100vh - 50px)', backgroundImage: "url('./img/module1/bg02.png')", backgroundRepeat: 'no-repeat', backgroundSize: 'cover', backgroundBlendMode: 'luminosity'  }}>
      <div className="container">
        <Page2 />
      </div>
    </section>,


    <section key="3" style={{ background: '#ffffff', minHeight: 'calc(100vh - 50px)' }}>
      <div className="container">
        <Page3 />
      </div>
    </section>,
    
    
    <section key="4" style={{ background: '#45588aff', minHeight: 'calc(100vh - 50px)' }}>
      <div style={{height: 'calc(100vh - 50px)'}}>
        <Page4 />
      </div>
    </section>,


    <section key="5" style={{ background: '#ffffff', minHeight: 'calc(100vh - 50px)' }}>
      <div className="container">
        <Page5 />
      </div>
    </section>,
    
    
    <section key="6" style={{ background: '#ffffff', minHeight: 'calc(100vh - 50px)' }}>
      <div className="container">
        <Page6 />
      </div>
    </section>,
    
    
    <section key="7" style={{ background: '#45588aff', minHeight: 'calc(100vh - 50px)' }}>
      <div style={{height: 'calc(100vh - 50px)'}}>
        <Page7 />
      </div>
    </section>,
    
    
    <section key="8" style={{minHeight: 'calc(100vh - 50px)', backgroundImage: "url('./img/module1/bg03.png')", backgroundRepeat: 'no-repeat', }}>
      <div style={{height: 'calc(100vh - 50px)'}}>
        <Page8 />
      </div>
    </section>,
    
    
    <section key="9" style={{minHeight: 'calc(100vh - 50px)' }}>
      <div className="container">
        <Page9 />
      </div>
    </section>,
    
    
    <section key="10" style={{ background: '#f1f5f9', minHeight: 'calc(100vh - 50px)' }}>
      <div className="container" style={{ minHeight: 'calc(100vh - 50px)'}}>
        <Page10 />
      </div>
    </section>,
    
    
    <section key="11" style={{ background: '#45588aff', minHeight: 'calc(100vh - 50px)' }}>
      <div style={{height: 'calc(100vh - 50px)'}}>
        <Page11 />
      </div>
    </section>,
    
    
    <section key="12" style={{ background: '#45588aff', minHeight: 'calc(100vh - 50px)' }}>
      <div style={{height: 'calc(100vh - 50px)'}}>
        <Page12 />
      </div>
    </section>,
    
    
    <section key="13" style={{ background: '#45588aff', minHeight: 'calc(100vh - 50px)' }}>
      <div style={{height: 'calc(100vh - 50px)'}}>
        <Page13 />
      </div>
    </section>,
    
    
    <section key="14" style={{ background: '#45588aff', minHeight: 'calc(100vh - 50px)' }}>
      <div className="container" style={{ minHeight: 'calc(100vh - 50px)'}}>
        <Page14 />
      </div>
    </section>,
    
    
    <section key="15" style={{minHeight: 'calc(100vh - 50px)' }}>
      <div className="container">
       <Page15 />
      </div>
    </section>,
    
    
    <section key="16" style={{ minHeight: 'calc(100vh - 50px)', backgroundImage: "url('./img/module1/bg01.png')", backgroundRepeat: 'no-repeat', backgroundSize: 'cover' }}>
      <div className="container">
        <Page16 />
      </div>
    </section>,
    
    
    <section key="17" style={{ minHeight: 'calc(100vh - 50px)' }}>
      <div style={{height: 'calc(100vh - 50px)'}}>
        <Page17 />
      </div>
    </section>,
    
    
    <section key="18" style={{ background: '#45588aff', minHeight: 'calc(100vh - 50px)' }}>
      <div style={{height: 'calc(100vh - 50px)'}}>
        <Page18 />
      </div>
    </section>,
    
    
    <section key="19" style={{ background: '#f1f5f9', minHeight: 'calc(100vh - 50px)' }}>
      <div className="container" style={{height: 'calc(100vh - 50px)'}}>
        <Page19 />
      </div>
    </section>,
    
    
    <section key="20" style={{ background: '#45588aff', minHeight: 'calc(100vh - 50px)' }}>
      <div className="container" style={{height: 'calc(100vh - 50px)'}}>
        <Page20 />
      </div>
    </section>,
    
    
    <section key="21" style={{ background: '#45588aff', minHeight: 'calc(100vh - 50px)' }}>
      <div style={{height: 'calc(100vh - 50px)'}}>
        <Page21 />
      </div>
    </section>,
    
    
    <section key="22" style={{ background: '#45588aff', minHeight: 'calc(100vh - 50px)' }}>
      <div style={{height: 'calc(100vh - 50px)'}}>
        <Page22 />
      </div>
    </section>,
    
    
    <section key="23" style={{ minHeight: 'calc(100vh - 50px)' }}>
      <div style={{height: 'calc(100vh - 50px)'}}>
        <Page23 />
      </div>
    </section>,


    <section key="24" style={{ minHeight: 'calc(100vh - 50px)' }}>
      <div className="container" >
        <Page24 />
      </div>
    </section>,


    <section key="25" style={{ background: '#f1f5f9', minHeight: 'calc(100vh - 50px)' }}>
      <div  className="container" style={{height: 'calc(100vh - 50px)'}}>
        <Page25 />
      </div>
    </section>,


    <section key="26" style={{ minHeight: 'calc(100vh - 50px)', backgroundImage: "url('./img/module1/bg04.png')", backgroundRepeat: 'no-repeat', backgroundSize: 'cover', backgroundBlendMode: 'screen' }}>
      <div  className="container" style={{height: 'calc(100vh - 50px)'}}>
        <Page26 />
      </div>
    </section>,
  ];

  const nextSection = () => {
    setCurrentSection((prev) => {
      const newIndex = Math.min(prev + 1, sections.length - 1);
      setInputPage(newIndex + 1);
      return newIndex;
    });
  };

  const prevSection = () => {
    setCurrentSection((prev) => {
      const newIndex = Math.max(prev - 1, 0);
      setInputPage(newIndex + 1);
      return newIndex;
    });
  };

  // Função para ir direto para a página digitada
  const goToPage = () => {
    let page = Number(inputPage);

    if (isNaN(page)) return;

    if (page < 1) page = 1;
    if (page > sections.length) page = sections.length;

    setCurrentSection(page - 1);
    setInputPage(page);
  };

return (
  <div className={`lesson-wrapper ${className}`}>
    {navigationMode === 'pagination' ? (
      <>
        <div className="lesson-content">
          {sections[currentSection]}
        </div>

        <div className="lesson-footer">
          <img 
            src="./img/icon/preview_page.png"
            onClick={prevSection}
            style={{ cursor: 'pointer', height: '30px', width: '35px' }}
            alt="Preview"
          />

          <input
            type="text"
            value={inputPage}
            onChange={(e) => setInputPage(e.target.value)}
            onBlur={goToPage}
            onKeyDown={(e) => e.key === 'Enter' && goToPage()}
            style={{
              width: '40px',
              height: '30px',
              textAlign: 'center',
              borderRadius: '7px',
              border: 'none',
            }}
          />

          <span>/ {sections.length}</span>

          <img 
            src="./img/icon/next_page.png"
            onClick={nextSection}
            style={{ cursor: 'pointer', height: '30px', width: '35px' }}
            alt="Next"
          />
        </div>
      </>
      
    ) : (
      sections.map((section) => section)
    )}
  </div>
);
};

export default Lesson;